module.exports = __webpack_public_path__ + "img/ke_404_foutmelding_illustratie.c656c3d.svg";